import { z } from 'zod';
export const guidanceDocumentSchema = z.object({ label: z.string().min(1), url: z.string().refine(value => value.startsWith('/forms/') || /^https:\/\//.test(value), 'Use an HTTPS source or a bundled blank form.') });
/** Policy data, shared by evaluation, evidence forms and agency settings (ADR-008). */
export const complianceRuleSchema = z.object({
    documents: z.array(guidanceDocumentSchema).max(10).default([]),
    instructions: z.string().max(4000).default(''),
    evidenceMode: z.enum(['standard', 'scope', 'reviewed', 'references', 'history-verification', 'signed', 'education', 'orientation', 'hepatitis-b', 'influenza']).default('standard'),
    reviewQuestion: z.string().trim().min(1).nullable().default(null),
    minimumChecks: z.number().int().min(1).max(10).nullable().default(null),
    firstReviewRequirementKey: z.string().trim().min(1).nullable().default(null),
    firstReviewMonths: z.number().int().min(1).max(120).nullable().default(null),
    reviewOwner: z.string().trim().min(1).default('HR'),
}).strict();
export const complianceDecisionSchema = z.object({
    requirementKey: z.string().trim().min(1),
    policyReference: z.string().trim().min(1).max(1000),
    approvedBy: z.string().trim().min(1).max(200),
    approvedAt: z.string().datetime(),
    minimumChecks: z.number().int().min(1).max(10).nullable().default(null),
}).strict();
export const complianceDecisionsSchema = z.array(complianceDecisionSchema).max(200).superRefine((rows, ctx) => {
    const keys = new Set();
    rows.forEach((row, index) => {
        if (keys.has(row.requirementKey))
            ctx.addIssue({ code: 'custom', path: [index, 'requirementKey'], message: 'Use one approved decision per requirement.' });
        keys.add(row.requirementKey);
    });
});
export function withComplianceDecision(rule, decisions = [], now) {
    const decision = decisions.find((row) => row.requirementKey === rule.rule.key && row.approvedAt <= now);
    if (!decision)
        return rule;
    const current = rule.policy.compliance;
    if (current.evidenceMode === 'references' && decision.minimumChecks === null)
        return rule;
    return { ...rule, policy: { ...rule.policy, compliance: { ...current,
                reviewQuestion: null, minimumChecks: current.evidenceMode === 'references' ? Math.max(current.minimumChecks ?? 0, decision.minimumChecks ?? 0) : current.minimumChecks,
            } } };
}
//# sourceMappingURL=compliance.js.map